module.exports = __webpack_public_path__ + "img/upload.c3c6e3de.png";